import { render, staticRenderFns } from "./tipo-sim.vue?vue&type=template&id=742d6cf8&"
import script from "./tipo-sim.vue?vue&type=script&lang=js&"
export * from "./tipo-sim.vue?vue&type=script&lang=js&"
import style0 from "./tipo-sim.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports